






















































































































import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { purchaseOrder } from '@/store/modules/purchaseOrder';
import { PoData } from '@/interface/store/purchaseOrder';

const namespace: string = 'request';

@Component
export default class PurchaseOrder extends Vue {
  @Action('setPurchaseOrder', { namespace }) c_setPurchaseOrder!: any;
  @Action('bulkUpdateRequest', { namespace }) c_bulkUpdateRequest!: any;
  @Action('poSignURI', { namespace }) c_poSignURI!: any;
  @Action('setPoAttachment', { namespace }) c_setPoAttachment!: any;
  @Action('getPoAttachments', { namespace: 'purchaseOrder' }) c_getPoAttachments!: any;
  @Action('getPoDetails', { namespace: 'purchaseOrder' }) c_getPoDetails!: any;
  @Action('deletePoAttachment', { namespace: 'purchaseOrder' }) c_deletePoAttachment!: any;

  @Mutation('INIT_PO_DETAILS', { namespace: 'purchaseOrder' }) c_INIT_PO_DETAILS!: any;

  @Getter('getterGroupsMemberships', { namespace: 'manageGroup' }) c_getterGroupsMemberships!: any;
  @Getter('getterPoList', { namespace }) c_getterPoList!: any;
  @Getter('getterPoData', { namespace: 'purchaseOrder' }) c_getterPoData!: PoData;
  @Getter('getterPoAttachment', { namespace: 'purchaseOrder' }) c_getterPoAttachment!: any;

  public ruleForm: any = {
    name: null,
  };
  public rules: any = {
    name: [{ required: true, message: 'PO 번호를 입력해주세요.', trigger: 'blur' }],
  };
  public fileNameArray: any = [];
  public filePayload: any = [];
  public dataItems: any = [];
  public deletedItems: any = [];
  public isLoading: boolean = false;

  async created() {
    const groupId: string = this.$route.params.groupId;
    const purchaseOrderId = this.$route.params.purchaseOrderId;

    if (purchaseOrderId) {
      await this.c_getPoDetails({ groupId, purchaseOrderId });
      await this.c_getPoAttachments({ groupId, purchaseOrderId });
      this.fileNameArray = this.c_getterPoAttachment;
      this.dataItems = this.c_getterPoData.fkOrderRequests;
      this.ruleForm.name = this.c_getterPoData.name;
    } else this.dataItems = this.$route.query.items;
  }

  get currentGroupName() {
    const groupId: string = this.$route.params.groupId;
    return this.c_getterGroupsMemberships.length > 1
      ? this.c_getterGroupsMemberships.find((v: any) => v.fkGroup.id === groupId).fkGroup.name
      : 'All Labs';
  }

  get getTotalTax() {
    return Math.round((this.getTotalPrice / 1.1) * 0.1);
  }

  get getTotalDelivery() {
    let total: number = 0;
    this.dataItems.forEach((v: any) => {
      if (v.fkPurchaseOrder !== null) total += v.fkPurchaseOrder.shipping.amount;
    });
    return total;
  }

  get getTotalPrice() {
    let total: number = 0;
    this.dataItems.forEach((v: any) => {
      total += v.price * v.quantity;
    });
    return total;
  }

  get sumPrice() {
    return this.dataItems.reduce((p: any, c: any) => p + c.price * c.quantity, 0);
  }

  get sumVat() {
    return this.dataItems.reduce((p: any, c: any) => p + Math.ceil(c.price * c.quantity * 0.1), 0);
  }

  get sumTotal() {
    return this.sumPrice + this.sumVat;
  }

  currentTotalPrice(item: any) {
    const quantity: number = item.quantity;
    const price: number = item.price;
    const totalPrice = quantity * price;
    const commaParse = totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return isNaN(totalPrice) ? 0 : commaParse;
  }

  attachFile(): void {
    (this.$refs.file as HTMLInputElement).click();
  }

  async addFile(e: any): Promise<void> {
    const purchaseOrderId = this.$route.params.purchaseOrderId;
    const groupId: string = this.$route.params.groupId;
    if (purchaseOrderId) {
      for (let i = 0; i < e.target.files.length; i++) {
        const file = e.target.files[i];
        try {
          const data = await this.c_setPoAttachment({ groupId, purchaseOrderId, files: [file] });
          const newFile: any = {
            fileName: file.name,
            url: `https://images.labsby.com/groups/${groupId}/purchase-order/${purchaseOrderId}/attachments/${file.name}`,
            id: data[0].id,
          };
          this.fileNameArray.push(newFile);
        } catch (e) {
          console.log(e);
          this.$message.error(e.response.data.error.message);
        }
      }
    } else {
      for (let i = 0; i < e.target.files.length; i++) {
        const file = e.target.files[i];
        this.fileNameArray.push({ fileName: file.name });
        this.filePayload.push(file);
      }
    }
  }

  async deleteFile(attachmentId: string): Promise<void> {
    const purchaseOrderId = this.$route.params.purchaseOrderId;
    const groupId: string = this.$route.params.groupId;
    if (purchaseOrderId) {
      await this.c_deletePoAttachment({ groupId, purchaseOrderId, attachmentId });
      this.fileNameArray = this.fileNameArray.filter((arr: any) => arr.id !== attachmentId);
    } else {
      const deleteIndex = this.fileNameArray.find((file: { id: string }, index: any) => {
        if (file.id === attachmentId) return index;
      });
      this.fileNameArray.splice(deleteIndex, 1);
    }
  }

  deleteItem(item: any) {
    const purchaseOrderId = this.$route.params.purchaseOrderId;
    this.dataItems.splice(this.dataItems.indexOf(item), 1);
    if (purchaseOrderId) {
      this.deletedItems.push(item);
    }
  }

  savePO() {
    const groupId: string = this.$route.params.groupId;
    (this.$refs.ruleForm as HTMLFormElement).validate(async (valid: boolean) => {
      if (valid) {
        const poCheck = this.c_getterPoList.find((op: any) => op.name === this.ruleForm.name);

        const savePoControl = async () => {
          try {
            this.isLoading = true;
            const updateArr: any = [];

            if (!poCheck) {
              // 기존에 없는 PO라서 새로 PO 생성
              const result = await this.c_setPurchaseOrder({
                groupId,
                poName: this.ruleForm,
              });

              this.dataItems.map((item: any) => {
                updateArr.push({
                  id: item.id,
                  fkPurchaseOrderId: result.id,
                });
              });

              if (this.filePayload.length > 0) {
                await this.c_setPoAttachment({
                  groupId,
                  purchaseOrderId: result.id,
                  files: this.filePayload,
                });
              }
            } else {
              // 기존에 있는 PO는 기존 PO 리스트에서 검색
              this.dataItems.map((item: any) => {
                updateArr.push({
                  id: item.id,
                  fkPurchaseOrderId: poCheck.id,
                });
              });

              if (this.filePayload.length > 0) {
                await this.c_setPoAttachment({
                  groupId,
                  purchaseOrderId: poCheck.id,
                  files: this.filePayload,
                });
              }
            }

            // PO 번호를 클릭해서 접속 후 삭제한 아이템이 있는 경우
            if (this.deletedItems.length) {
              this.deletedItems.map((item: any) => {
                updateArr.push({
                  id: item.id,
                  fkPurchaseOrderId: null,
                });
              });
            }

            await this.c_bulkUpdateRequest({
              groupId,
              payload: updateArr,
            });

            this.isLoading = false;
            this.$router.go(-1);

            if (!poCheck) this.$message.success('새로운 PO를 생성하였습니다.');
          } catch (e) {
            this.isLoading = false;
            throw e;
          }
        };

        if (poCheck) {
          this.$confirm(
            `'${this.ruleForm.name}' PO 번호는 이미 존재합니다. PO 번호를 합치시겠습니까?`,
            'PO 번호 합치기',
            {
              confirmButtonText: '확인',
              cancelButtonText: '취소',
              type: 'success',
            }
          )
            .then(async () => {
              await savePoControl();
            })
            .catch((e: Error) => {
              console.log(e);
              return false;
            });
        } else {
          await savePoControl();
        }
      } else {
        this.$message.error('유효하지 않은 형식의 데이터가 있습니다.');
        return false;
      }
    });
  }

  cancelPO() {
    this.$router.go(-1);
  }

  beforeDestroy() {
    this.c_INIT_PO_DETAILS();
  }
}
